import BuildingType from '@/roc/building/BuildingType';
import BuildingMaxLevel from '@/roc/building/BuildingMaxLevel';
import Effects from '@/roc/effects/Effects';
import CultureBonus from '@/roc/effects/CultureBonus/CultureBonus';
import CultureAmount from '@/roc/effects/CultureBonus/CultureAmount';
import CultureRange from '@/roc/effects/CultureBonus/CultureRange';

const LittleCultureSite = {
  id: '18',
  name: 'Little Culture Site',
  width: 1,
  height: 1,
  type: BuildingType.CULTURE,
  era: 'bronzeAge',
  icon: 'Culture_Range',
  minLevel: 2,
  maxLevel: BuildingMaxLevel.ONE_OFF,
  url: 'https://riseofcultures.wiki.gg/wiki/Home_Cultures/Culture_Sites/Little_Culture_Site',
  flags: 0,
  counts: {
    stoneAge: null,
    bronzeAge: 3,
    minoanEra: 4,
    classicGreece: 4,
    earlyRome: 5,
    romanEmpire: 6,
    byzantineEra: 7,
    ageOfTheFranks: 7,
    feudalAge: 7,
    iberianEra: 7,
    kingdomOfSicily: 7,
    highMiddleAges: 8,
    earlyGothicEra: 9,
    lateGothicEra: 10,
  },
  effects: Effects.create([
    new CultureBonus(
      CultureAmount.asPerLevel([0, 70, 80, 90, 100, 120, 140, 160, 190, 220, 260, 310, 350, 390]),
      CultureRange.asFlat(1),
    ),
  ]),
};

export default LittleCultureSite;
